import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'user',
			component: () => import(/* webpackChunkName: "user" */ './views/user/User.vue'),
			children: [
				{
					path: '',
					component: () => import(/* webpackChunkName: "userHome" */ './views/user/UserHome.vue')
				},
				{
					path: 'channels',
					component: () => import(/* webpackChunkName: "userChannels" */ './views/user/UserChannels.vue'),
					children: [
						{
							path: '',
							component: () => import(/* webpackChunkName: "userChannelsHome" */ './views/user/UserChannelsHome.vue')
						},
						{
							path: ':id',
							component: () => import(/* webpackChunkName: "userChannel" */ './views/user/UserChannel.vue'),
						}
					],
				}
			]
		},
		{
			path: '/admin',
			component: () => import(/* webpackChunkName: "admin" */ './views/admin/Admin.vue'),
			children: [
				{
					path: '',
					component: () => import(/* webpackChunkName: "adminHome" */ './views/admin/AdminHome.vue')
				},
				{
					path: 'channels',
					component: () => import(/* webpackChunkName: "adminChannels" */ './views/admin/AdminChannels.vue'),
					children: [
						{
							path: '',
							component: () => import(/* webpackChunkName: "adminChannelsHome" */ './views/admin/AdminChannelsHome.vue')
						},
						{
							path: ':id',
							component: () => import(/* webpackChunkName: "adminChannel" */ './views/admin/AdminChannel.vue')
						},
						{
							path: ':id/score',
							component: () => import(/* webpackChunkName: "adminChannelScore" */ './views/admin/AdminChannelScore.vue')
						}
					]
				},
				{
					path: 'management',
					component: () => import(/* webpackChunkName: "adminManagement" */ './views/admin/AdminManagement.vue')
				},
			]
		},
	],
});
